import { useAppContext } from "app/AppContext";
import InscricaoForm from "entity/Inscricao/components/InscricaoForm";
import InscricaoConsulta from "entity/Inscricao/components/InscricaoConsulta";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PublicInscricaoForm from "../../../entity/Inscricao/components/InscricaoPublic"
import BasicRoute from "components/routes/BasicRoute";
import PainelDoInscrito from "entity/Inscricao/components/PainelDoInscrito";
import InscricaoSimplificada from "entity/Inscricao/components/InscricaoSimplificada";

export default function RoutesMenusInscricao() {
    const navigate = useNavigate();
    const { addMenu, addRoute, removeMenusRoutes } = useAppContext();

    useEffect(() => {
        addRoute({ uid: "inscricao", title: "Inscricao", route: "inscricao", element: <InscricaoForm /> });
        addRoute({ uid: "publicInscricao", title: "Inscricao Pública", route: "public-inscricao", element: <PublicInscricaoForm /> });

        // addMenu({
        //     uid: "consultaInscricao",
        //     text: "Inscrições",
        //     sequence: "000007",
        //     iconName: "AppRegistration",
        //     action: () => {
        //         navigate("/consulta-inscricao");
        //     },
        // });

        addRoute({ uid: "consultaInscricao", title: "Inscricoes", route: "consulta-inscricao", element: <InscricaoConsulta /> });


        return () => {
            removeMenusRoutes(["inscricao", "consultaInscricao"]);
        };
    }, [addMenu, addRoute, navigate, removeMenusRoutes]);

    return <>
        <BasicRoute
            uid='PainelDoInscrito'
            route="painel-inscrito"
            // menuProps={{
            //     text: "Inscrição Publica",
            //     sequence: "000009",
            //     iconName: "Public",
            // }}
            element={<PainelDoInscrito />}
        />
        <BasicRoute
            uid='inscrever-se'
            route="inscrever-se"          
            element={<InscricaoSimplificada />}
        />
    </>;
}